import React, { Component } from 'react';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class OfferModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
  }

  handleToggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.handleToggle}
          className="eir-offer-modal"
          centered={this.props.centered}
        >
          <ModalHeader toggle={this.handleToggle} />
          <ModalBody>
            <div className="container">
              <div className="col align-self-center">
                {this.props.image ? 
                  (<a href={this.props.modalLink}><img className="img-fluid" src={this.props.imageURL} alt={this.props.imageAlt} /> </a>) :
                  (<img className="img-fluid" src="https://www.eir.ie/opencms/export/system/handler/contents/eir_180x180.png" />)
                }
                <h4>{this.props.title}</h4>
                <p>{this.props.text}</p>
               
              </div>
              
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default OfferModal;
